import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { SecondaryNavComponent } from '../secondary-nav/secondary-nav.component';

/**
 * Persistent application shell (see spec section 6). Mounted once at the
 * root route; every feature route renders inside <router-outlet> here.
 */
@Component({
  selector: 'pp-app-shell',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, TopbarComponent, SecondaryNavComponent],
  templateUrl: './app-shell.component.html',
})
export class AppShellComponent {}
